import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ProgressComponent } from './progress/progress.component';
import { Graficas1Component } from './graficas1/graficas1.component';
import { PagesComponent } from './pages.component';
import { SharedModule } from '../shared/shared.module';
import { PagesRoutingModule } from './pages-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IncrementComponent } from '../components/increment/increment.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { GraficoDonaComponent } from '../components/grafico-dona/grafico-dona.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AccountSettingsComponent } from './account-settings/account-settings.component';

import { environment } from 'src/environments/environment';

import { AngularFireModule } from '@angular/fire';
import { AngularFireAuthModule } from "@angular/fire/auth";
import { AngularFirestoreModule } from '@angular/fire/firestore';
import {
  AngularFireStorageModule,
}
from '@angular/fire/storage';
import { PipesModule } from '../pipes/pipes.module';
import { ProfileComponent } from './profile/profile.component';

import {MatTableModule} from '@angular/material/table';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatSortModule} from '@angular/material/sort';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

import {MatSlideToggleModule} from '@angular/material/slide-toggle';

import { CustomersComponent } from './customers/customers/customers.component';
import { CustomerformComponent } from './customers/customerform/customerform.component';
import { CustomerComponent } from './customers/customer/customer.component';
import { OrdersComponent } from './orders/orders/orders.component';
import { OrderformComponent } from './orders/orderform/orderform.component';
import { AsignorderComponent } from './orders/asignorder/asignorder.component';
import { OrderdetailsComponent } from './orders/orderdetails/orderdetails.component';

import {NgxMaterialTimepickerModule} from 'ngx-material-timepicker';
import { EditcustomerformComponent } from './customers/editcustomerform/editcustomerform.component';
import { RegionComponent } from './region/region.component';
import { ColorPickerModule } from 'ngx-color-picker';
import { TrackingComponent } from './drivers/tracking/tracking.component';
import { UsersComponent } from './userscompanys/users/users.component';
import { UserformComponent } from './userscompanys/userform/userform.component';
import { EdituserformComponent } from './userscompanys/edituserform/edituserform.component';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatSelectModule} from '@angular/material/select';
import {MatDatepickerModule} from '@angular/material/datepicker';
import { MatNativeDateModule, MAT_DATE_FORMATS, MatDateFormats, MAT_DATE_LOCALE } from '@angular/material/core';
import {MatDialogModule} from '@angular/material/dialog';

import {MatIconModule} from '@angular/material/icon';
import { EditorderComponent } from './orders/editorder/editorder.component';
import { ChartsModule } from 'ng2-charts';
import { HistoryordersComponent } from './orders/historyorders/historyorders.component';
import { CarsformComponent } from './cars/carsform/carsform.component';
import { CarsComponent } from './cars/cars/cars.component';
import { EditcarformComponent } from './cars/editcarform/editcarform.component';
import { RequestordersComponent } from './orders/requestorders/requestorders.component';
import { ClientsappComponent } from './customers/clientsapp/clientsapp.component';


import { ItemsformComponent } from './itemssettings/itemsform/itemsform.component';
import { ItemsComponent } from './itemssettings/items/items.component';

import { ItemeditComponent } from './itemssettings/itemedit/itemedit.component';
import { DialogComponent } from '../components/dialog/dialog.component';


@NgModule({
  declarations: [
    DashboardComponent,
    ProgressComponent,
    Graficas1Component,
    PagesComponent,
    IncrementComponent,
    GraficoDonaComponent,
    AccountSettingsComponent,
    ProfileComponent,
    UsersComponent,
    UserformComponent,
    EdituserformComponent,
    CustomersComponent,
    CustomerformComponent,
    CustomerComponent,
    OrdersComponent,
    OrderformComponent,
    AsignorderComponent,
    OrderdetailsComponent,
    EditcustomerformComponent,
    RegionComponent,
    TrackingComponent,
    EditorderComponent,
    HistoryordersComponent,
    CarsformComponent,
    CarsComponent,
    EditcarformComponent,
    RequestordersComponent,
    ClientsappComponent,
    ItemsComponent,
    ItemsformComponent,
    ItemeditComponent,
    DialogComponent,
  ],
  exports: [
    DashboardComponent,
    ProgressComponent,
    Graficas1Component,
    PagesComponent,
    IncrementComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    PagesRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgxChartsModule,
    BrowserAnimationsModule,
    PipesModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSlideToggleModule,
    NgxMaterialTimepickerModule,
    ColorPickerModule,
    MatCheckboxModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatIconModule,
    ChartsModule,
  ],
  providers: [{ provide: MAT_DATE_LOCALE, useValue: 'es-ES' }],
  bootstrap: [],
})
export class PagesModule {}
